import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';

import * as yup from 'yup';
import { valid } from 'semver';

/** Semantic Versioning (SemVer) format version number validator */
export const semVerSchema = yup
  .string()
  .test({
    name: 'sem-ver-schema',
    message: DtoMessageEnum.INVALID_SEM_VER,
    test: (value, context) => {
      if (!value) {
        return context.schema?.spec?.optional || context.schema?.spec?.nullable;
      }
      return Boolean(valid(value));
    },
  });

/** Semantic Versioning (SemVer) format version number validator (extended version with `latest` alias support) */
export const semVerOrLatestSchema = yup
  .string()
  .test({
    name: 'sem-ver-or-latest-schema',
    message: DtoMessageEnum.INVALID_SEM_OR_LATEST_VER,
    test: value => (value || '').toLowerCase() === 'latest' || Boolean(valid(value)),
  });
